import React, { useEffect, useRef, useState } from 'react'
import Layout from '../common/Layout'
import ApiHelper from '../../helperFunction/ApiHelper'
import API_ENDPOINTS from '../../helperFunction/Constant'
import { useNavigate, useParams } from 'react-router-dom'
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { ConfirmDialog } from 'primereact/confirmdialog'
import { Toast } from 'primereact/toast'
import { IconField } from 'primereact/iconfield'
import { InputIcon } from 'primereact/inputicon'
import { InputText } from 'primereact/inputtext'


const CustomerOrders = () => {

    const { id } = useParams()

    const toast = useRef(null)
    const [globalFilterValue, setGlobalFilterValue] = useState('');

    const [customers, setCustomers] = useState([])
    const navigate = useNavigate()

    useEffect(() => {
        getCustomers()
    }, [])

    const getCustomers = () => {
        ApiHelper.get(`${API_ENDPOINTS.CUSTOMER_ORDERS}/${id}`).then((res) => {
            console.log('res: ', res);
            if (res.status === 200) {
                setCustomers(res.data.data)
            }
        }).catch((error) => {
            console.log("Error: ", error);
        })
    }

    // const serialNoTemplate = (rowData, options) => { return options.rowIndex + 1; };

    const imageBodyTemplate = (rowData) => {
        return (
            rowData?.courseImage ? (
                <div style={{ display: "flex", alignItems: "center", gap: "10px"}} >
                    <img
                        src={`${process.env.REACT_APP_BASE_URL}/${rowData?.courseImage}`}
                        alt=""
                        style={{ width: 'auto', height: '50px', objectFit: 'cover' }}
                        onError={(e) => {
                            e.target.src = "/img/placeholder-image.jpg"
                        }}
                    />
                    {rowData?.courseName}
                </div>
            ) : null
        );
    };

    const statusBodyTemplate = (rowData) => {
        return (
            <span className={`badge ${rowData.paymentStatus === 'success' ? 'bg-success' : 'bg-danger'}`}>
                {rowData.paymentStatus === 'success' ? 'Success' : 'Failed'}
            </span>
        );
    };
    
    const renderHeader = () => {
        return (
            <div className="flex justify-content-end">
                <IconField iconPosition="left">
                    <InputIcon className="pi pi-search" />
                    <InputText value={globalFilterValue} onChange={(e) => setGlobalFilterValue(e.target.value)} placeholder="Search" />
                </IconField>
            </div>
        );
    };

    return (
        <>
            <Toast ref={toast} />
            <ConfirmDialog />
            <Layout>
                <div class="content-wrapper">
                    <div class="container-xxl flex-grow-1 container-p-y">
                        <div class="d-flex justify-content-between align-items-center py-3">
                            <h4 class="fw-bold py-3 mb-2">
                                <span class="d-flex text-muted fw-light"> 
                                    <p class="breadcrumb-item pageHeader active me-2 mb-0" aria-current="page" onClick={() => navigate('/customers')}> Customers </p> / <b className='mx-2'> Orders </b>
                                </span>
                            </h4>
                            {/* <Link class="btn btn-primary" to={'/customers/add'} >Add New Customer</Link> */}
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <div class="card mb-4">
                                    <div class="card-body">
                                        <DataTable globalFilter={globalFilterValue} header={renderHeader} paginator rows={50} rowsPerPageOptions={[50, 100, 150, 200]} showGridlines size="small" value={customers} tableStyle={{ minWidth: '50rem' }} >
                                            <Column sortable header='Order ID' field='orderId' />
                                            <Column sortable header='Course Name' body={imageBodyTemplate} field='courseName' />
                                            <Column sortable header='Order Number' field='orderNumber' />
                                            <Column sortable header='Order Date' field='createdAt' body={(rowData) => {
                                                const date = new Date(rowData.createdAt);
                                                return date.toLocaleDateString("en-US", { year: "numeric", month: "short", day: "2-digit", hour: "2-digit", minute: "2-digit", hour12: true, });
                                            }} />
                                            <Column sortable header='Total' field='grandTotal' />
                                            <Column sortable header='RazorPay Order ID' field='razorpayOrderId' />
                                            <Column sortable header='Payment Method' field='paymentMethod' />
                                            <Column sortable header='Failed Reason' field='failureReason' />
                                            <Column sortable header='Status' body={statusBodyTemplate} />
                                        </DataTable>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Layout>
        </>
    )
}

export default CustomerOrders
